export default __webpack_public_path__ + "static/media/cfd_whitepaper.fee2c853.png";